import React from 'react';
import { Divider, Grid, Image, Typography } from 'antd';
import '../../../Styles/Linkages&Outreach.css'; 
import wsw2026Poster from "../../../Assets/Linkages/WorldSpaceWeek/WSW-2026-Modules.jpg"
const { useBreakpoint } = Grid;


const { Title, Paragraph } = Typography;
const LatestUpdates = () => {
    const screens = useBreakpoint();
  return (
    <div className="latest-updates-section">
      <div className="text-container">
        <Title level={2} className="section-title">Latest Updates</Title>
        <Divider className="ncgsa-divider" />

        <Paragraph style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} className="description">
          NCGSA organizes a diverse portfolio of specialized events, training programs, workshops, conferences, and seminars aimed at promoting space awareness and outreach. These initiatives are strategically designed to nurture intellectual curiosity, bridge knowledge gaps, and create meaningful learning opportunities for students, educators, researchers, and professionals alike. Through these targeted engagements, NCGSA seeks to cultivate a scientifically informed society and inspire active participation in the evolving landscape of space science. Below are the latest activities planned to quench the thirst of inquisitive minds.
        </Paragraph>
      </div>

      <div className="latest-update-poster">
        <Image
          preview={false}
          src={wsw2026Poster}
          alt="World Space Week 2026 Rocket Revolution poster"
          className="latest-update-poster-image"
        />
      </div>
    </div>
  );
};

export default LatestUpdates;
